/**
 * Максимальная длина комментария к отказу от подписания. Обе мутации отказа — `rejectSigning`
 * и `rejectExternalSigning` — пишут его в колонку `DIGSIGN_SIGNING_FLOW_SIGNER.REJECTION_COMMENT
 * varchar(10000)` (`SigningFlowSigner.rejectionComment`): более длинный PostgreSQL отвергнет.
 */
export const REJECTION_COMMENT_MAX_LENGTH = 10000;
